import React from 'react';
import { Modal, TouchableWithoutFeedback, useWindowDimensions } from "react-native";
import { View } from '../../../src/Components/Themed';
import { CompetitionModule, SquaresModule } from 'be-components';
import type { CompanyProps, LocationProps, MyPlayerProps, PlayerBalanceProps } from '../../../src/types';
import MarketHeader from '../../market2/components/MarketHeader';

type CompetitionHolderProps = {
    mode:'desktop'|'mobile',
    visible: boolean,
    me?:MyPlayerProps,
    distinct_id:string,
    my_balance?:PlayerBalanceProps,
    competition_id?:string,
    location?:LocationProps,
    company:CompanyProps,
    insets: { top:number, bottom:number, left:number, right:number },
    onClose:() => void,
    onShowProfile:() => void,
    onShowWallet: () => void,
    onRequestAuthenticate:() => void,
    onRequestLocation:() => void
}
const CompetitionHolder = ({ visible, competition_id, distinct_id, company, me, my_balance, mode, insets, onShowProfile, onShowWallet, onClose, onRequestAuthenticate, onRequestLocation }:CompetitionHolderProps) => {
    const { height } = useWindowDimensions();
    let desktop_height = height - insets.top - insets.bottom
    if(desktop_height > 850){ desktop_height = 850 }
    return (
        <Modal
            style={{ flex:1 }}
            transparent
            animationType={mode=='desktop' ? 'fade' : 'slide'}
            visible={visible}
        >
            <TouchableWithoutFeedback style={{ flex:1 }} onPress={() => onClose()}>
            <View type='blur' style={mode=='desktop' ? { flex:1, justifyContent:'center', alignItems:'center' }:{ flex:1, padding:10 }}>
                <View transparent style={mode=='desktop'? {  borderRadius:22, width:550, height: desktop_height }:{ flex:1, paddingBottom:insets.bottom }}>
                    <TouchableWithoutFeedback>
                    <View float style={{ flex:1 }}>
                        <MarketHeader 
                            me={me}
                            onClose={() => onClose()}
                            header_style={{ borderTopRightRadius:8, borderTopLeftRadius:8 }}
                            my_balance={my_balance}
                            mode={mode}
                            company={company}
                            onShowProfile={() => {
                                onClose()
                                onShowProfile()
                            }}
                            onShowWallet={() => {
                                onClose()
                                onShowWallet()
                            }}
                            onRequestAuthenticate={() => onRequestAuthenticate()}
                        />
                        {competition_id ?
                        <View style={{ flex:1, maxHeight:height - insets.top - insets.bottom - 45 }}>
                            <CompetitionModule
                                competition_id={competition_id}
                                player_id={me?.player_id}
                                onRequestAuthentication={onRequestAuthenticate}
                                onViewCompetitionSeason={() => console.log('')}
                                view_mode={mode}
                                onClose={() => onClose()}
                                onShareCompetition={() => console.log('')}
                                insets={insets}
                            />
                        </View>
                        :<></>}
                    </View>
                    </TouchableWithoutFeedback>
                </View>
            </View>
            </TouchableWithoutFeedback>
        </Modal>
    )
}

export default CompetitionHolder